import * as yup from 'yup'
import i18next from '../../i18n/i18n'

export interface UpdateEmailFormValues {
  currentPassword: string
  newEmail: string
  newEmailConfirmation: string
}

export const createUpdateEmailSchema = (
  currentEmail?: string
): yup.ObjectSchema<UpdateEmailFormValues> =>
  yup
    .object({
      currentPassword: yup.string().required(),
      newEmail: yup
        .string()
        .email()
        .required()
        .test(
          'notCurrentEmail',
          i18next.t('form.errors.emailSameAsCurrent'),
          (value) =>
            currentEmail == null ||
            value == null ||
            value.trim().toLowerCase() !== currentEmail.trim().toLowerCase()
        ),
      newEmailConfirmation: yup
        .string()
        .required()
        .oneOf(
          [yup.ref('newEmail')],
          i18next.t('form.errors.emailConfirmation')
        ),
    })
    .required()
